const exported = {
    TV_VIDEO_SHOWS_PATH: "/live/shows",
    DIGITAL_ORIGINALS_PATH: "/digitaloriginals",
    SCHEDULED_VIDEO_SHOWS_PATH: "/live/schedule-shows",
    SCHEDULED_RADIO_SHOWS_PATH: "/audio",
};

export const {
    TV_VIDEO_SHOWS_PATH,
    DIGITAL_ORIGINALS_PATH,
    SCHEDULED_VIDEO_SHOWS_PATH,
    SCHEDULED_RADIO_SHOWS_PATH,
} = exported;
